import { OnlineStatusStore } from '../common/general/online-status/online-status.store';
import { LocalizationStore } from '../common/localization/general/localization.store';
import { UrlStore } from '../common/url/url.store';

class RootStore {
  public readonly urlStore = new UrlStore();
  public readonly onlineStatusStore = new OnlineStatusStore();
  public readonly localizationStore = new LocalizationStore(this.urlStore);
}

export const rootStore = new RootStore();
